var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-contanier" },
    [
      _c("div", { staticClass: "opt" }, [
        _c(
          "div",
          { staticClass: "btn", on: { click: _vm.add } },
          [
            _c("svg-icon", { attrs: { className: "icon", iconClass: "add" } }),
            _vm._v("新增 "),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height !== 0
            ? _c("BaseTable", {
                attrs: {
                  height: _vm.height,
                  tableData: _vm.tableData,
                  pageIndex: _vm.pagerConfig.pageIndex,
                  pageSize: _vm.pagerConfig.pageSize,
                  pageSizes: [20, 30, 50, 100],
                  loading: _vm.loading,
                  isEmptyBorder: true,
                },
                on: { handlePageChange: _vm.handlePageChange },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "isActived",
                      fn: function (row) {
                        return [
                          _c("div", {
                            staticClass: "circle",
                            style: {
                              "background-color": row.scope.isActived
                                ? " #35BA83"
                                : "#FE453D",
                            },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(
                                row.scope.isActived ? "使用中" : "未使用"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: "opt",
                      fn: function (row) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover${row.scope.id}`,
                              attrs: {
                                placement: "bottom-start",
                                "popper-class": "pop-table-opt",
                                width: "114",
                                trigger: "click",
                              },
                            },
                            [
                              _c("div", { staticClass: "table-opt" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "opt-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.updateRow(row.scope)
                                      },
                                    },
                                  },
                                  [_vm._v("修改")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "opt-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.customers(row.scope)
                                      },
                                    },
                                  },
                                  [_vm._v("下属客户")]
                                ),
                              ]),
                              _c("img", {
                                staticStyle: { "margin-left": "-14px" },
                                attrs: {
                                  slot: "reference",
                                  src: require("@/assets/images/table/opt.png"),
                                },
                                slot: "reference",
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3256500235
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("add-accounts-receivable-dialog", {
        attrs: { dialogVisible: _vm.dialogVisible, editData: _vm.editData },
        on: { ok: _vm.ok, cancel: _vm.cancel },
      }),
      _c("subordinate-customers-dialog", {
        attrs: {
          bankAccountId: _vm.editData.id,
          dialogFormVisible: _vm.dialogFormVisible,
        },
        on: { ok: _vm.ok2, cancel: _vm.cancel2 },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }